<template>
    <button
        type="button"
        class="a-logo logo"
        @click="redirectToHome"
        :aria-label="ariaLabel"
    >
        <svg-icon
            original
            name="logo"
            class="logo__icon"
        />
    </button>
</template>

<script>
import { TERMINAL_START } from '../../../utils/constants/pages'
    
export default {
    name: 'ALogo',
    props: {
        ariaLabel: {
            type: String,
            default: 'Logo button'
        }
    },
    methods: {
        redirectToHome() {
            if (this.$route.name === TERMINAL_START) return;
            const params = {
                name: TERMINAL_START
            };
            this.$router.push(params);
        }
    }
}
</script>

<style lang="scss">
@import "a-logo";
</style>
